<script>
  import api from '@/api'
  import isEqual from 'lodash/isEqual'

  export default {
    name: 'FilteredData',
    render: (h) => h(),
    props: {
      value: {},
      map: {},
      endpoint: {},
      filtersValue: {
        default: function () {
          return {}
        },
      },
      sort: {},
      date: {},
      exclude: null,
      externalFilters: null,
      refresh: false,
    },
    data () {
      return {
        data: {},
        page: 1,
        loading: false,
        hasMore: true,
      }
    },
    watch: {
      refresh (need) {
        if (need) {
          this.refreshData()
        }
      },
      hasMore () {
        this.$emit('update:hasMore', this.hasMore)
      },
      loading () {
        this.$emit('update:loading', this.loading)
      },
      sort (newSort, oldSort) {
        if (!isEqual(newSort, oldSort)) {
          this.updateData()
        }
      },
      filtersValue (newFiltersValue, oldFiltersValue) {
        if (!isEqual(newFiltersValue, oldFiltersValue)) {
          this.updateData()
        }
      },
      map () {
        if (this.map == null) {
          return this.getData()
            .then((data) => {
              this.data = data
              this.$emit('input', this.data)
            })
        } else {

          return this.getDataForMap()
            .then((data) => {
              this.data = data
              this.$emit('input', this.data)
            })
        }
      },
      date: {
        handler: function () {
          this.page = 1
          return this.getData()
            .then((data) => {
              this.data = data
              this.$emit('input', this.data)
            })
        },
        deep: true,
      },
      externalFilters (newFiltersValue, oldFiltersValue) {
        if (!isEqual(newFiltersValue, oldFiltersValue)) {
          this.updateData()
        }
      },
    },

    methods: {
      /**
       * Load new data based on new filters values that user selected
       */
      updateData () {
        this.page = 1
        return this.getData()
          .then((data) => {
            this.data = data
            this.$emit('input', this.data)
          })
      },

      loadMore () {
        this.page++
        return this.getData()
          .then((data) => {
            data.data.forEach((item) => this.data.data.push(item))

            this.$emit('input', this.data)
          })
      },

      getData () {
        this.loading = true

        if (this.map != null) {
          this.filtersValue.map = this.map
        } else {
          if (this.filtersValue.map) {
            delete (this.filtersValue.map)
          }
        }

        const params = {
          page: this.page,
          filters: this.filtersValue,
          sort: this.sort,
          date: this.date,
        }
        if (this.exclude) params.exclude = this.exclude
        if (this.externalFilters) params.external = this.externalFilters

        return api
          .get(this.endpoint, {params})
          .then(({data}) => {
            this.loading = false

            if (data.next_page_url === null) {
              this.hasMore = false
            } else {
              if (data.per_page) {
                this.hasMore = !!(data && data.data && data.data.length && data.data.length >= data.per_page)
              } else {
                this.hasMore = !!(data && data.data && data.data.length)
              }
            }

            return data
          })
      },
      getDataForMap () {
        this.loading = true

        if (this.map != null) {
          this.filtersValue.map = this.map
        } else {
          if (this.filtersValue.map) {
            delete (this.filtersValue.map)
          }
        }

        return api
          .get('machines/map', {
            params: {
              page: this.page,
              filters: this.filtersValue,
              sort: this.sort,
              date: this.date,
            },
          })
          .then(({data}) => {
            this.loading = false

            // @todo: check if length < perPage and set hasMore = false
            if (data && data.data && data.data.length) {
              this.hasMore = true
            } else {
              this.hasMore = false
            }

            return data
          })
      },
      refreshData () {
        this.updateData()
        this.$emit('update:refresh', false)
      },
    },
    mounted () {
      if (this.filtersValue) {
        this.updateData()
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filtered-data.vue